import React from 'react';
import NavOne from './NavOne';

const HeaderTwo = () => {
    return(
        <>
        <header className="o-header">
            <NavOne />
        </header>
        </>
    )
}

export default HeaderTwo;